export const HTMLFontSize = 14 as const;

export const RefreshTokenErrorMessage = "Refresh token does not exist" as const;
export const MAX_LIMIT_QUERY = 500;
